import { useSearchParams, useNavigate, Link, useParams } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from "react";
import { LeftOutlined,HeartFilled, HeartOutlined,CopyOutlined, WhatsAppOutlined, SendOutlined, } from "@ant-design/icons";
import { PageName, ThemeButton,ThemeCollapse, ButtonContainer, StyledCard } from './style';
import { Card, Collapse, Row, Col, Grid, Tooltip,  message, Typography } from "antd";
import { MySegmented, MyText } from "../../components";
import { fetchArticleList, fetchAutorsList } from '../../api'; 
import {useTranslation} from "react-i18next";
import {Cookies} from "react-cookie";
import { COOKIE_KEY, fetchArticleByIdAction, fetchArticleListAction, fetchAutorsListAction, fetchSetLikeAction, fetchThemeListAction } from "../../utils";

import { useLocation } from 'react-router-dom';
import { useEmbeddedNavigate, useEmbeddedLink } from "../../utils/context/embed";
import {Helmet} from "react-helmet";
import { useLang } from "../../utils/context/lang";
import { useDispatch, useSelector } from "react-redux";

const { Panel } = Collapse;
const isMobile = window.innerWidth < 768;

const ArticlesDetailsPage = () => {
  const {t} = useTranslation("common")
  const cookies = new Cookies()
  const location = useLocation();

  const {handleChangeLang, lang} = useLang()
  
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const dispatch = useDispatch();
  const themeList = useSelector((state: any) => state.articles.themeList);
  const themes = themeList.data || [];
  const [searchParams, setSearchParams] = useSearchParams();
  const params = new URLSearchParams(location.search);
  const initialView = params.get('view') === 'list' ? 'list' : 'grid';
  const [viewMode, setViewMode] = useState(initialView);
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const segmentedParams = searchParams.get('type');
  const themeParam = searchParams.get('theme');
  const { articleId } = useParams();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  // const [themes, setThemes] = useState([]);
  const initialTopicIdRaw = searchParams.get('topic_id');
  const initialPagedRaw = searchParams.get('page');
  const initialTopicId = initialTopicIdRaw ? Number(initialTopicIdRaw) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState(initialTopicId);
  const [articles, setArticles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [authors, setAuthors] = useState([]);
  const [likedArticles, setLikedArticles] = useState<{ [key: number]: boolean }>({});
  const [likeCounts, setLikeCounts] = useState<{ [key: number]: number }>({});
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();  
  const { Link } = Typography;
  const url = window.location.origin + location.pathname + location.search;
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const articleById = useSelector((state: any) => state.materials?.articleById);  
  const articleList = useSelector((state: any) => state.articles.articleList);
  const autorsList = useSelector((state: any) => state.articles.autorsList);
  const formatDate = (dateString, lang) => {
    const date = new Date(dateString);
    const locale = lang === 'kk' ? 'kk-KZ' : 'ru-RU';
  
    const kazakhMonths = [
      'қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым',
      'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан'
    ];
  
    const optionsDate = { year: 'numeric', month: 'long', day: 'numeric' };
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false, hourCycle: 'h23' };
  
    let formattedDate = new Intl.DateTimeFormat(locale, optionsDate).format(date);
    const formattedTime = new Intl.DateTimeFormat(locale, optionsTime).format(date);
  
    if (lang === 'kk') {
      const monthIndex = date.getMonth();
      const kazakhMonth = kazakhMonths[monthIndex];
      
      formattedDate = formattedDate.replace(
        /(\d{1,2})\s[\wа-яё]+\s(\d{4})/i, 
        `$1 ${kazakhMonth} $2`
      );
    }
  
    return `${formattedDate} ${formattedTime}`.replace(/г\.\s*/, '');
  };

// const toggleLike = (articleId: number) => {
//     setLikedArticles((prev) => ({
//       ...prev,
//       [articleId]: !prev[articleId],
//     }));

//     setLikeCounts((prev) => ({
//       ...prev,
//       [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
//     }));
    
//     fetchSetLike(articleId, 'article');
//   };
const toggleLike = (articleId: number) => {
  setLikedArticles((prev) => ({
    ...prev,
    [articleId]: !prev[articleId],
  }));
  setLikeCounts((prev) => ({
    ...prev,
    [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
  }));
  dispatch(fetchSetLikeAction({ entity_id: articleId, entity_type: 'article' }));
};

  const handleClick = () => {
  const topicPart = initialTopicId && initialTopicId !== 0 ? `&topic_id=${initialTopicId}` : '';
  const pagePart = initialPagedRaw ? `&page=${initialPagedRaw}` : '';
  embeddedNavigate(`/articles?type=articles${topicPart}&view=${viewMode}${pagePart}`);
};

  const SPECIALIST_TYPE = [
    { key: 'articles', title: `${t("articles")}` },
    { key: 'authors', title: `${t("authors")}` },
  ];

  const handleCopy = () => {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = url;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    message.success('Ссылка скопирована');
  } catch {
    message.error('Не удалось скопировать');
  }
};


  // useEffect(() => {
  //   const loadArticle = async () => {
  //     setLoading(true);
  //     try {
  //       const articleData = await fetchArticleById(articleId);
  //       setArticle(articleData);
  //     } catch (error) {
  //       console.error('Error fetching article:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (articleId) {
  //     loadArticle();
  //   }
  // }, [articleId]);

  useEffect(() => {
    if (articleId) {
      dispatch(fetchArticleByIdAction(articleId));
    }
  }, [articleId]);

  useEffect(() => {
  if (!articleById?.data) return;

  setArticle(articleById.data);
}, [articleById?.data]);


  useEffect(() => {
    if (!article || typeof article !== 'object') return;
  
    setLikedArticles({ [article.id]: article.is_liked_by_user });
    setLikeCounts({ [article.id]: article.like_count });
  }, [article]);

  const handleChangeSegmented = (value) => {
    if (value === 'authors') {
      setSearchParams({ type: 'authors' });
      embeddedNavigate('/articles?type=authors');
    } else {
      setSearchParams({ type: 'articles' });
    }
  };


  const handleChangeTheme = (theme) => {
    setSearchParams({ type: segmentedParams || 'articles', theme });
  };

  useEffect(() => {
      dispatch(fetchThemeListAction({}));
    }, []);

  useEffect(() => {
    if (!articleList.success || !articleList.data) return;
    setArticles(articleList.data.list || []);
    setTotalCount(articleList.data.total_count || 0);
  }, [articleList.success, articleList.data]);

  useEffect(() => {
    if (!autorsList.success || !autorsList.data) return;
    setAuthors(autorsList.data);
  }, [autorsList.success, autorsList.data]);

const parentThemes = themes.filter(theme => theme.parent_id === 0);

    const handlePanelChange = (key) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };

  return (
    <>
      <Helmet>
        <title>Статьи для родителей и педагогов</title>
        <meta name="description" content="Полезные статьи для родителей и педагогов: развитие, воспитание, обучение детей от раннего возраста до дошкольного" />
      </Helmet>

    <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
      <Row justify='center'>
      <Col span={20} >
      <Row justify="space-between" align="middle" gutter={[ screens.xs ? 52 : 32, 24]}>
        
        <div style={{ marginBottom: screens.xs ? 0 :'24px', marginLeft: screens.xs ? 22 : 0 }}>
          <MySegmented
            type='primary'
            options={SPECIALIST_TYPE.map(item => ({
              label: item.title,
              value: item.key
            }))}
            onChange={handleChangeSegmented}
            value={segmentedParams}
          />
        </div>

        <Row 
        // style={{ width: screens.xs ? 'auto' : '100%' }} 
        style={{ width: '100%' }} 

        gutter={[screens.xs ? 0 : 24, screens.xs ? 0 : 24]}>
          <Col span={screens.xs || isTablet ? 24 : 18} style={{padding: "10px !important"}}>
            <StyledCard style={{ borderRadius: '20px' }}>
            <PageName>
              {/* <div style={{ display: 'flex', gap: '32px', justifyContent: 'space-between', marginBottom: '24px', alignItems: 'center' }}> */}
              <div style={{  marginBottom: screens.xs ? '0px' : '24px' }}>
                <Row align="middle">
                {/* {!screens.xs && ( */}
                    <Col span={screens.xs ? 3 : 2}>
                      <ButtonContainer onClick={handleClick}>
                        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                      </ButtonContainer>
                    </Col>
                  {/* )} */}
                          <Col span={screens.xs ? 21 : 22}>

                          <MyText color="#0A033C" size={screens.xs ? 20 : 26} weight={800}
                                  style={{fontFamily: 'Nunito', display: 'block', marginLeft: screens.xs ? 12: 0}}>
                            {article?.header || t("articlesLoading")} 
                          </MyText>
                          </Col>
                        </Row>
              </div>

              <div style={{ gap: '24px', flexWrap: 'wrap' }}>
          {loading ? null : (
            <div style={{
              display: 'flex',
              marginTop: '24px',
              width: '100%',
              flexDirection: viewMode === 'grid' ? 'column' : 'row',
            }}>
              {article?.image && (
                <div style={{
                  width: '100%',
                  height: '500px',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}>
                  <img
                    src={article.image} 
                    alt="Article"
                    style={{
                      width: '100%',
                      height: '500px',
                      // height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <Col span={24} style={{marginTop: 16, padding: "0px !important"}}>
                          <MyText color="#0A033C" size={screens.xs ? 16 : 18} weight={600}
                                  style={{fontFamily: 'Nunito', display: 'block'}}>
                            {article?.author_name} 
                          </MyText>
                          </Col>
                           <Col span={24} style={{marginTop: 16, padding: "0px !important"}}>
                          <MyText color="#0A033C" size={screens.xs ? 16 : 18} weight={600}
                                  style={{fontFamily: 'Nunito', display: 'block'}}>
                            {article?.description} 
                          </MyText>
                          </Col>
                          <Col span={24} style={{marginTop: 20, padding: "0px !important"}}>
                  <MyText color="#0A033C" size={20} style={{ fontFamily: 'Nunito' }}>
                  <div
                    style={{
                      fontFamily: 'Nunito',
                      lineHeight: '26px',
                      fontSize: screens.xs ? '18px' : '20px',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: article?.content
                        ?.replace(/<p([^>]*)>/gi, '<p$1 style="margin-bottom:0.2em;">')
                        .replace(
                          /<iframe([^>]*?)style="([^"]*)"([^>]*)>/gi,
                          '<iframe$1style="$2; width:100%;"$3>'
                        )
                        .replace(
                          /<iframe([^>]*)>/gi,
                          '<iframe$1 style="width:100%;">'
                        ),
                    }}
                  />
                </MyText>
          </Col>

          <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: screens.xs ? 0 : 12 }}>
  <Col>
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <div style={{ display: 'flex', gap: viewMode === 'grid' ? 6 : 8, alignItems: 'center' }}>
        {article && (likedArticles[article.id] ?? article.is_liked_by_user) ? (
          <HeartFilled
            style={{
              fontSize: 16,
              color: 'rgba(253, 99, 99, 1)',
              cursor: 'pointer',
            }}
            onClick={token ? () => toggleLike(article.id) : undefined}
          />
        ) : (
          <HeartOutlined
            style={{
              fontSize: 16,
              color: 'rgba(104, 114, 125, 1)',
              cursor: 'pointer',
            }}
            onClick={token ? () => toggleLike(article.id) : undefined}
          />
        )}
        {article && likeCounts[article.id] > 0 && (
          <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
            {likeCounts[article.id]}
          </MyText>
        )}
      </div>

      {article?.created_at && (
        <MyText color="rgba(104, 114, 125, 1)" size={16}>
          {formatDate(article.created_at, lang)}
        </MyText>
      )}
    </div>
  </Col>

  <Col style={{marginTop: screens.xs ? 6 : 0}}>
  <Row gutter={12} align="middle">
  <Col>
    <MyText color="#0A033C" size={16} weight={600} style={{ fontFamily: 'Nunito' }}>
      {t("share")}:
    </MyText>
  </Col>

  <Col>
    <Tooltip title="Telegram" mouseEnterDelay={0.3} mouseLeaveDelay={0.1}>
      <Link
        href={`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <SendOutlined style={{ fontSize: 18, color: '#0088cc' }} />
      </Link>
    </Tooltip>
  </Col>

  <Col>
    <Tooltip title="WhatsApp" mouseEnterDelay={0.3} mouseLeaveDelay={0.1}>
      <Link
        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsAppOutlined style={{ fontSize: 18, color: '#25D366' }} />
      </Link>
    </Tooltip>
  </Col>

  <Col>
    <Tooltip title="Скопировать ссылку" mouseEnterDelay={0.3} mouseLeaveDelay={0.1}>
      <span onClick={handleCopy} style={{ cursor: 'pointer' }} tabIndex={-1}>
        <CopyOutlined style={{ fontSize: 18, color: '#6c757d' }} />
      </span>
    </Tooltip>
  </Col>
</Row>
</Col>
</Row>

             
            </PageName>
          </StyledCard>
          {/* <Col span={24} style={{marginTop: 20}}>
          <MyText color='#0A033C' size={20} style={{ fontFamily: 'Nunito' }}>
          <div
            style={{ fontFamily: 'Nunito', lineHeight: '26px', fontSize: '20px' }}
            dangerouslySetInnerHTML={{
              __html: article?.content?.replace(/<p(.*?)>/g, '<p$1 style="margin-bottom: 0.2em;">'),
            }}
          />
                </MyText>
          </Col> */}
          {/* <Col span={24}>
            <div style={{ display: 'flex', width: '100%', alignItems: 'center',gap: 16, marginTop: '12px' }}>
                  <div style={{ display: 'flex', gap: viewMode === 'grid' ? '6px' : '8px', alignItems: 'center' }}>
                  {article && (likedArticles[article.id] ?? article.is_liked_by_user) ? (
                  <HeartFilled
                    style={{
                      fontSize: "16px",
                      color: "rgba(253, 99, 99, 1)",
                      cursor: "pointer",
                    }}
                    onClick={token ? () => toggleLike(article.id) : undefined}
                  />
                ) : (
                  <HeartOutlined
                    style={{
                      fontSize: "16px",
                      color: "rgba(104, 114, 125, 1)",
                      cursor: "pointer",
                      height: '24px'
                    }}
                    onClick={token ? () => toggleLike(article.id) : undefined}
                  />
                )}
                <Col>
                {article && likeCounts[article.id] > 0 && (
                  <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
                    {likeCounts[article.id]}
                  </MyText>
                )}
                </Col>
                  </div>
                  {article?.created_at && (
                      <MyText color="rgba(104, 114, 125, 1)" size={16}>
                        {formatDate(article.created_at, lang)}
                      </MyText>
                    )}
                </div>
            </Col> */}
          
          </Col>

          {!(screens.xs || isTablet) && (
          <Col span={6}>
            <StyledCard style={{ width: '100%', borderRadius: '20px' }}>
          <PageName>
        <MyText color="#0A033C" size={18} weight={800} style={{ marginBottom: '16px', fontFamily: 'Nunito' }}>
          {t("articles")}
        </MyText>            
        {[{ id: null, name: t("all") }, ...parentThemes].map(parentTheme => {
  const childThemes = parentTheme.id ? themes.filter(theme => theme.parent_id === parentTheme.id) : [];

  return childThemes.length === 0 ? (
    <li
      key={parentTheme.id ?? 'all'}
      style={{ marginBottom: '8px', cursor: 'pointer', fontSize: '18px' }}
      // onClick={async () => {
      //   setActiveKeyTheme(null);
      //   setSelectedSubThemeId(parentTheme.id);
      //   setSearchParams(prevParams => {
      //     if (parentTheme.id === null) {
      //       prevParams.delete('topic_id');
      //     } else {
      //       prevParams.set('topic_id', parentTheme.id);
      //     }
      //     return prevParams;
      //   });

      //   if (parentTheme.id === null) {
      //     embeddedNavigate(`/articles?type=articles`);
      //   } else {
      //     embeddedNavigate(`/articles?type=articles&topic_id=${parentTheme.id}&view=${viewMode}`);
      //   }

      //   try {
      //     if (segmentedParams === 'authors') {
      //       const authorList = await fetchAutorsList(null, parentTheme.id);
      //       setAuthors(authorList);
      //     } else {
      //       const response = await fetchArticleList(null, null, parentTheme.id);
      //       setArticles(response?.list);
      //     }
      //   } catch (error) {
      //     console.error('Error fetching content:', error);
      //   }
      // }}
      onClick={() => {
        setActiveKeyTheme(null);
        setSelectedSubThemeId(parentTheme.id);
        setSearchParams(prevParams => {
          if (parentTheme.id === null) {
            prevParams.delete('topic_id');
          } else {
            prevParams.set('topic_id', parentTheme.id);
          }
          return prevParams;
        });

        if (parentTheme.id === null) {
          embeddedNavigate(`/articles?type=articles`);
        } else {
          embeddedNavigate(`/articles?type=articles&topic_id=${parentTheme.id}&view=${viewMode}`);
        }

        if (segmentedParams === 'authors') {
          dispatch(fetchAutorsListAction({ fio: null, theme_id: parentTheme.id }));
        } else {
          dispatch(fetchArticleListAction({ theme_id: parentTheme.id }));
        }
      }}
    >
      <div
        style={{
          background: selectedSubThemeId === parentTheme.id ? "rgba(231, 250, 255, 1)" : '#fff',
          borderRadius: '8px',
          padding: '12px',
          border: '1px solid #d9d9d9'
        }}
      >
        <MyText
          color={selectedSubThemeId === parentTheme.id ? 'rgba(0, 141, 210, 1)' : '#0A033C'}
          size={18}
          weight={600}
        >
          {parentTheme.name}
        </MyText>
      </div>
    </li>
  ) : (
    <ThemeCollapse
      activeKey={activeKeyTheme}
      onChange={handlePanelChange}
      style={{ marginBottom: '8px', background: '#fff' }}
      key={parentTheme.id}
    >
      <Panel
        header={
          <MyText color="#0A033C" size={18} weight={600}>
            {parentTheme.name}
          </MyText>
        }
        key={parentTheme.id}
      >
        <ul style={{ padding: 0, listStyleType: 'none' }}>
          {childThemes.map(subTheme => (
            <li
              key={subTheme.id}
              style={{
                marginBottom: '8px',
                cursor: 'pointer',
                fontSize: '18px',
                color: selectedSubThemeId === subTheme.id ? 'rgba(0, 141, 210, 1)' : '#0A033C'
              }}
              // onClick={async () => {
              //   setSelectedSubThemeId(subTheme.id);
              //   setSearchParams(prevParams => {
              //     prevParams.set('topic_id', subTheme.id);
              //     return prevParams;
              //   });
              //   embeddedNavigate(`/articles?type=articles&topic_id=${subTheme.id}&view=${viewMode}`);
              //   try {
              //     if (segmentedParams === 'authors') {
              //       const authorList = await fetchAutorsList(null, subTheme.id);
              //       setAuthors(authorList);
              //     } else {
              //       const response = await fetchArticleList(null, null, subTheme.id);
              //       setArticles(response?.list);
              //     }
              //   } catch (error) {
              //     console.error('Error fetching content:', error);
              //   }
              // }}
              onClick={() => {
                setSelectedSubThemeId(subTheme.id);
                setSearchParams(prevParams => {
                  prevParams.set('topic_id', subTheme.id);
                  return prevParams;
                });
                embeddedNavigate(`/articles?type=articles&topic_id=${subTheme.id}&view=${viewMode}`);
                
                if (segmentedParams === 'authors') {
                  dispatch(fetchAutorsListAction({ fio: null, theme_id: subTheme.id }));
                } else {
                  dispatch(fetchArticleListAction({ theme_id: subTheme.id }));
                }
              }}
            >
              {subTheme.name}
            </li>
          ))}
        </ul>
      </Panel>
    </ThemeCollapse>
  );
})}
          </PageName>
          </StyledCard>
          </Col>
          )}
          </Row>
        </Row>
        </Col>
      </Row>
    </Row>
    </>
  );
};

export default ArticlesDetailsPage;
